import React from "react";
import "./AP.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import aboutimg from "../../Media/Kaia.webp";
import {faCheckDouble} from "@fortawesome/free-solid-svg-icons";

const About = () => {
  const handleConsultationClick = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6287876666122&text=Halo%20Anggi,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Grand%20Wisata%20(Fasilitas)%20https://perumahan-grand-wisata.com//&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };

  return (
    <div className="aboutproduk">
      <div id="fasilitas" className="container-about">
        <h1>The Beauty & A World Class Home Resort</h1>
        <div className="container-desk">
          <div className="desk">
            Selamat Datang di Grand Wisata Bekasi, Guna meningkatkan kenyamanan
            penghuninya Grand Wisata juga memberikan berbagai fasilitas lengkap
            dan terintegrasi yang dapat dinikmati oleh seluruh penghuninya.
          </div>
        </div>
        <div className="container-benefit">
          <div className="benefit-list">
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#00234B" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Clubhouse
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#00234B" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;One Gate System
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#00234B" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Futsal Court
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#00234B" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Basketball Court
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#00234B" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Tennis Court
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#00234B" />
              <span style={{color: "rgb(84, 84, 84)"}}>&nbsp;&nbsp;Gym</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#00234B" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Swimming Pool
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#00234B" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Jogging Track
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#00234B" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Security 24 Hours
              </span>
            </div>
          </div>
        </div>
        <div className="button">
          <div className="container-wa">
            <button
              className="buttonpenawaran"
              onClick={handleConsultationClick}>
              Learn More
            </button>
          </div>
        </div>
      </div>
      <div className="gambarabout">
        <img src={aboutimg} alt={aboutimg} />
      </div>
    </div>
  );
};

export default About;
